import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md } from '../../theme/Component/hooks/useModal';
import { _ResourceCost } from '../../../core/services/dataBean/EntityCatalogVdos';
import { Modal } from '../../theme/Component/Modal';
import { BasicTable } from '../../theme/Component/BasicTable';
import { CostingCenterSelect } from '../../erp/cellEditor/CostingCenter/CostingCenterSelect';
import { SelectIndirectConstType } from '../IndirectCostType/SelectIndirectConstType';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EditorResourceCost = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ResourceCost)
    const [id, setID] = useState(null);
    const [CostingCenter, setCostingCenter] = useState<number>(null)
    const [IndirectCostType, setIndirectCostType] = useState<number>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const modal = useModal("Materia Prima", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [CostingCenter, IndirectCostType, regexStr])


    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDResourceCost == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getResourceCostCatalog(CostingCenter, IndirectCostType, regexStr).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.CostingCenter = (user.DataBeanProperties.CostingCenterCode ?? "") + "-" + (user.DataBeanProperties.CostingCenterName ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDResourceCost', visible: true },
        { title: 'Tipo Costo Indirecto', property: 'IndirectCostTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },

        { title: 'Centro de Costo', property: 'CostingCenter', visible: true },
        { title: 'Unidad de Medida', property: 'CostingMeasurementUnitName', visible: true },
        { title: 'Costo Estandard', property: 'StandardValue', visible: true },
        { title: 'Costo Real', property: 'RealValue', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Costos de Recursos"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <CostingCenterSelect fKey="IDCostingCenter" idSelector={CostingCenter} onChange={(e) => { setCostingCenter(parseFloat(e)) }} label="Centro de Costo" />
                    </div>
                    <div className="col-md-4">
                        <SelectIndirectConstType idSelector={IndirectCostType} onChange={(e) => { setIndirectCostType(e) }} label="Tipo de  Costo Indirecto" returnType="ID" />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-12"><BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDResourceCost); modal.close(); }}></BasicTable></div>
                </div>

            </Modal>
        </>
    )
}